const getKey = (alias: string | undefined, idx: number, tableId: string) => `${tableId}_${alias}_${idx}`.toUpperCase().replace('-', '_');

export default getKey;
